type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never }[keyof T];

export const sortByNumber = <T extends Record<string, any>, K extends KeysMatching<T, number>>(
  array: T[],
  key: K
): T[] => {
  const compareNumbers = (a: T, b: T): number => {
    return a[key] - b[key];
  };
  return array.sort(compareNumbers);
};

export default sortByNumber;
